module.exports = __webpack_public_path__ + "img/benefits-empty-image.d6aead98.webp";